import type { CoachMarkSpec } from '@/features/coach-marks';

export const BRIEF_MENU_COACH_MARK: CoachMarkSpec = {
  id: 'briefInMenu',
  version: 'v1',
  title: 'Meeting prep lives here',
  description: 'You can generate or reopen your meeting prep from this menu.',
  width: 'sm',
};

export const GENERATE_SUMMARY_COACH_MARK: CoachMarkSpec = {
  id: 'generateSummary',
  version: 'v2',
  title: "Summarize when you're ready",
  description:
    "Short recordings don't summarize automatically, so you can resume if the meeting isn't over.",
  width: 'md',
};
